




















































import { Component, Vue, Ref } from 'vue-property-decorator';
import NoticeBox from '@/components/common/NoticeBox.vue';
import { getStorageFile } from '@/pro/utils/storage';
import { range1ToN } from '@/pro/utils/common';
import { getToday, changeDateFormat } from '@/utils/dateUtils';
import { readExcelFile } from '@/utils/excel';
import { ParsedObject } from '@/pro/utils/fileReader';
import { NCPResponse, PostMembersMemberNosExcel } from 'ncp-api-supporter';

@Component({
  components: { NoticeBox },
})
export default class ExcelBatchRegistrationPopup extends Vue {
  @Ref() private readonly fileInputRef: HTMLInputElement;

  private readonly noticeList = range1ToN(4, 'ACCUMULATION_PAYMENT_REQUEST_EXCEL_BATCH_REGISTRATION_NOTICE_');
  private uploadedExcelFile: File | null = null;
  private uploadedExcelFileName = '';
  private fileInputStyle = ''; //파일명 길이에 따라 width 가변하도록 설정
  private excelMembers: number[] = []; //엑셀에서 추출된 회원번호

  private async readExcel(): Promise<void> {
    const MEMBER_NO = this.$t('ACCUMULATION_PAYMENT_REQUEST_MEMBER_NO');
    const keyMapJson = { memberNos: MEMBER_NO };
    readExcelFile(this.uploadedExcelFile, keyMapJson, await this.fetchExcelMembers);
  }

  private async fetchExcelMembers(excelData: ParsedObject[]): Promise<void> {
    //엑셀을 읽어 회원번호만 배열로 리턴
    const memberNos = excelData.flatMap((row) => {
      return Number(Object.values(row));
    });
    this.excelMembers = memberNos;
  }

  private checkExcelValid(): boolean {
    const MAXIMUM_FIVE_MEGA_BYTE = 1024 * 1024 * 5;
    const MAXIMUM_LENGTH_TEN_THOUSAND = 10000;
    //엑셀 파일 업로드 안함
    if (!this.uploadedExcelFileName || !this.uploadedExcelFile) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_NO_DATA'));
      return false;
    }
    //윈도우에서 확장자 무시 발생 - 유효성 검사 후 업로드 방지 
    if(!this.uploadedExcelFileName.includes('.xlsx')){
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_NO_DATA'));
      this.handleDeleteExcelClick();
      return false;
    }
    //데이터 없거나 다른 열에 있음 | 엑셀 양식 - 첫 행부터 시작여부 확인 | 엑셀에 문자열 존재여부 체크(기획엔 없지만 방어코드용)
    const isIncorrectExcelFormat =
      !this.excelMembers.length || !this.excelMembers[0] || this.excelMembers.includes(NaN);
    if (isIncorrectExcelFormat) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_INVALID_EXCEL_FILE'));
      return false;
    }
    if (this.excelMembers.length >= MAXIMUM_LENGTH_TEN_THOUSAND) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_MAXIMUM_LENGTH_TEN_THOUSAND'));
      return false;
    }
    //5메가바이트 초과
    if (this.uploadedExcelFile.size > MAXIMUM_FIVE_MEGA_BYTE) {
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_MAXIMUM_FILE_SIZE_FIVE_MEGA_BYTE'));
      return false;
    }
    return true;
  }

  private async uploadExcel(): Promise<PostMembersMemberNosExcel> {
    const formData = new FormData();
    const mallNo = Number(this.$route.query.mallNo);
    formData.append('excelFile', this.uploadedExcelFile);
    const { data: excelData }: NCPResponse<PostMembersMemberNosExcel> = await this.$api.postMembersMemberNosExcel({
      params: { mallNo },
      data: formData,
    });
    return excelData;
  }
  private close() {
    window.close();
  }
  private handleDownloadExcelClick(): void {
    const TEMPLATE_FILE_NAME = 'target_member_template.xlsx';
    const excelFileName = this.$t('ACCUMULATION_PAYMENT_REQUEST_BATCH_REGISTRATION_EXCEL_SAMPLE', {
      todayDate: changeDateFormat(getToday(), 'YYYYMMDD'),
    });
    getStorageFile(TEMPLATE_FILE_NAME, 'excel-sample', excelFileName as string);
  }

  private handleUploadExcelChange({ currentTarget }: { currentTarget: HTMLInputElement }): void {
    const excelFile = currentTarget.files[0]; // not multiple
    if (!excelFile) {
      return;
    }
    if (!excelFile.name.includes('.xlsx')) { //not accept
      alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_WRONG_FILE_FORMAT'));
      return;
    }

    this.fileInputStyle = `width: ${5 * excelFile.name.length}px;`;
    this.uploadedExcelFileName = excelFile.name;
    this.uploadedExcelFile = excelFile;
    this.readExcel();
  }
  private handleDeleteExcelClick(): void {
    this.fileInputStyle = '';
    this.uploadedExcelFile = null;
    this.uploadedExcelFileName = '';
    this.fileInputRef.value = '';
  }

  private async handleSaveClick(): Promise<void> {
    if (!this.checkExcelValid()) {
      return;
    }
    const {memberNos, failCounts} = await this.uploadExcel();
    const successCount = memberNos.length;
    const failCount = failCounts;
    const callbackData = {
      memberCount: successCount,
      selectedMembers: memberNos,
    };

    alert(this.$t('ACCUMULATION_PAYMENT_REQUEST_SAVE_STATUS_ALERT', { successCount, failCount }));
    if (this.$route.query?.callback) {
      $(window.opener.location).attr(
        'href',
        `javascript:window.${this.$route.query.callback}(${JSON.stringify(callbackData)});`
      );
    }
    this.close();
  }
}
